export default __webpack_public_path__ + "static/gunner_small-ca82230c166f87a39e1b6b1474252e3e.webp";